import script from "./CalculatorResult.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatorResult.vue?vue&type=script&setup=true&lang=js"

import "./CalculatorResult.vue?vue&type=style&index=0&id=e584c9b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e584c9b4"]])

export default __exports__